import {
  GET_INSTITUTION_CURRENT_POSITION_REQUEST,
  GET_INSTITUTION_CURRENT_POSITION_SUCCESS,
  GET_INSTITUTION_CURRENT_POSITION_FAILURE,
  statusType
} from '../../../actions'

const initial = {
  data: null,
  status: statusType.IDLE
}

const institutionCurrentPositionReducer = (state = initial, action) => {
  switch (action.type) {
    case GET_INSTITUTION_CURRENT_POSITION_REQUEST:
      return {
        ...state,
        data: action.payload,
        status: statusType.IN_PROGRESS
      }
    case GET_INSTITUTION_CURRENT_POSITION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: statusType.SUCCESS
      }
    case GET_INSTITUTION_CURRENT_POSITION_FAILURE:
      return {
        ...state,
        data: action.payload,
        status: statusType.ERROR
      }
    default:
      return state
  }
}

export default institutionCurrentPositionReducer
